/** Dates are shown one way everywhere, whatever the phone's region: "Oct 10, 2026". */
export function formatDate(d: Date): string {
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

/** "Oct 10, 2026 14:03" */
export function formatDateTime(d: Date): string {
  return `${formatDate(d)} ${d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })}`
}
